import RefTreeComponet from './RefTreeComponet'
import { TopNavPage, NavUtils } from 'mutants-mobile-navigator';


@TopNavPage
export default class RefTree extends RefTreeComponet {
  
}
